export default __webpack_public_path__ + "static/media/87t.11b13610.jpg";